<template>
  <div class="full-height">
    <q-card class="full-width full-height">
      <q-card-actions class="bg-accent text-white q-pa-md">
        <div class="title">
          {{
            formData.hasOwnProperty("id")
              ? `Business #${formData.id}`
              : "New Business"
          }}
        </div>
        <q-space></q-space>
        <!-- <q-btn
          color="primary"
          style="width: 100px"
          class="q-mr-sm sustainability-button"
          @click="save"
        >
          Save
        </q-btn> -->
        <!-- <q-btn
          :loading="isLoading"
          style="width: 100px; background-color: #6dbf50"
          class="q-mr-sm sustainability-button"
          @click="save(false, true)"
        >
          Save & Add New
        </q-btn> -->
        <q-btn
          color="primary"
          style="width: 100px"
          :loading="saveLoading"
          class="q-mr-sm sustainability-button"
          @click="save(true, false)"
        >
          Save & Close
        </q-btn>

        <q-btn @click="closeDialog" flat icon="mdi-close" size="5" round />
      </q-card-actions>
      <q-card-section class="q-pa-none">
        <q-tabs v-model="tab" align="left">
          <q-tab v-for="(tabItem, i) in tabs" :key="i" :name="tabItem.name">
            <div style="display: inline">
              <span class="tabTitle">{{ tabItem.label }} </span>
              <q-icon
                name="mdi-alert-circle"
                color="red"
                v-if="tabItem.isError"
              >
              </q-icon>
            </div>
          </q-tab>
        </q-tabs>

        <q-tab-panels v-model="tab" animated keep-alive ref="tabs">
          <!---GENERAL-->
          <q-tab-panel name="general">
            <div class="row" v-if="newBusiness">
              <div class="col-12">
                <span class="text-bold"
                  >Create Sustainability Business from existing an Upstream
                  Business</span
                >
                <Autocomplete
                  label="Existing Business"
                  :id="formData.id"
                  clearable
                  :items="businessList"
                  option_label="name"
                  option_value="id"
                  :loading="businessListLoading"
                  @changed="loadFormDataFromExistingBusiness"
                />
              </div>
              <div class="col-12 q-mt-md">
                <span class="text-bold"
                  >Or create new Business from the below</span
                >
              </div>
            </div>
            <div class="row q-mb-sm items-center q-mt-none">
              <div class="col-12">
                <div class="title q-my-none q-mt-lg">General</div>
              </div>
            </div>
            <div class="row">
              <span class="text-grey" style="max-width: 600px">
                Please upload a Business Logo
              </span>
            </div>
            <q-form ref="form">
              <div class="row q-my-sm">
                <!-- IMG Section -->
                <div class="col-auto q-pa-sm">
                  <div v-if="changeImage || !formData.imageUrl">
                    <div style="width: 300px">
                      <croppa
                        ref="imgCroppa"
                        :height="200"
                        :width="300"
                        v-model="myCroppa"
                        remove-button-color="#68c6d2"
                        :show-loading="true"
                        :loading-size="50"
                        crossOrigin="anonymous"
                        :quality="2"
                        :prevent-white-space="false"
                      ></croppa>
                    </div>
                    <div class="row" style="width: 300px">
                      <span class="text-caption">
                        (this is the image used as the business logo throughout
                        Sustainability )
                      </span>
                    </div>
                    <div class="row" style="width: 300px">
                      <span class="text-caption"
                        >Recommended .jpg/.jpeg files and ideally 500Kb
                      </span>
                    </div>
                  </div>

                  <div v-else style="margin: auto; width: 300px">
                    <q-img
                      :src="formData.imageUrl"
                      style="width: 300px; height: 200px"
                      v-if="formData.id"
                    >
                    </q-img>
                    <q-btn
                      class="full-width"
                      color="primary"
                      label="Change"
                      @click="changeImage = true"
                      v-if="formData.id"
                    >
                    </q-btn>

                    <div class="row">
                      <span class="text-caption">
                        ( This is the logo for the Business )
                      </span>
                    </div>
                    <div class="row">
                      <span class="text-caption">
                        Recommended .jpg/.jpeg files and ideally 500Kb
                      </span>
                    </div>
                  </div>
                </div>
                <!-- Info Box Section -->
                <div class="col q-pa-sm">
                  <div class="row q-col-gutter-x-md">
                    <div class="col-12 col-md-6">
                      <q-input label="Name" v-model="formData.name"> </q-input>
                    </div>
                    <div class="col-12 col-md-6">
                      <q-input label="website" v-model="formData.website">
                      </q-input>
                    </div>
                    <div class="col-12">
                      <q-input label="Email" v-model="formData.email">
                      </q-input>
                    </div>
                    <div class="col-12">
                      <q-input
                        label="Owner Email"
                        v-model="formData.ownerEmail"
                      >
                      </q-input>
                    </div>
                    <div class="col-12 col-md-6">
                      <q-input label="Owner Name" v-model="formData.ownerName">
                      </q-input>
                    </div>
                    <div class="col-12 col-md-6">
                      <q-input
                        label="Owner Mobile"
                        v-model="formData.ownerMobile"
                      >
                      </q-input>
                    </div>
                    <div class="col-12 col-md-6">
                      <q-input
                        label="Owner Contact Person"
                        v-model="formData.ownerContactPerson"
                      >
                      </q-input>
                    </div>
                    <div class="col-12 col-md-6">
                      <q-input
                        label="Invoice Email"
                        v-model="formData.invoiceEmail"
                      >
                      </q-input>
                    </div>
                  </div>
                </div>
              </div>
            </q-form>
          </q-tab-panel>
          <!---Outcome Access-->
          <q-tab-panel name="outcomeAccess">
            <div class="row q-mb-sm items-center">
              <div class="col-9">
                <div class="row items-center q-col-gutter-x-md">
                  <div class="title q-my-none q-mx-none">Outcome Access</div>

                  <div style="width: 200px">
                    <q-form ref="outcomeAccessForm">
                      <q-select
                        :options="filteredOutcomesList"
                        v-model="selectedOutcome"
                        label="Outcomes"
                        map-options
                        emit-value
                        option-value="id"
                        option-label="name"
                      >
                      </q-select>
                    </q-form>
                  </div>
                  <div>
                    <q-btn
                      :disabled="!selectedOutcome"
                      color="primary"
                      @click="addOutcomeAccess"
                    >
                      <q-icon name="mdi-plus-circle"> </q-icon>
                      <span class="sustainability-font q-mx-sm"> Add </span>
                    </q-btn>
                  </div>
                </div>
              </div>
              <div class="col-3">
                <q-input
                  class="searchbar float-right"
                  style="max-width: 70%"
                  filled
                  v-model="searchText"
                  debounce="200"
                  label="Search"
                  clearable
                  dense
                >
                  <template #prepend>
                    <q-icon name="mdi-magnify"></q-icon>
                  </template>
                </q-input>
              </div>
            </div>

            <data-table
              style="height: calc(100vh - 270px)"
              headerBgColor="#162c47"
              headerTextColor="white"
              :columns="outcomeAccessColumns"
              :data="outcomeAccessList"
              flat
              :filter="searchText"
            >
              <template slot="body-cell-actions" slot-scope="data">
                <q-td :props="data.props">
                  <q-btn
                    flat
                    @click="saveOutcomeAccess(data.props.row)"
                    size="md"
                    class="float-right text-white"
                    :class="{
                      'bg-positive': data.props.row.status == 1,
                      'bg-negative': data.props.row.status == 0,
                    }"
                  >
                    {{ data.props.row.status == 1 ? "Active" : "Inactive" }}
                    <q-tooltip content-class="bg-accent" :offset="[10, 10]">
                      {{
                        data.props.row.status == 1
                          ? "Make Inactive"
                          : "Make Active"
                      }}
                    </q-tooltip>
                  </q-btn>
                </q-td>
              </template>
            </data-table>
          </q-tab-panel>
        </q-tab-panels>
      </q-card-section>
    </q-card>
  </div>
</template>

<script>
  import { mapGetters } from "vuex";
  import DataTable from "@/components/datatable/datatable.vue";
  import Autocomplete from "@/components/autocomplete/autocomplete.vue";
  import moment from "moment";

  export default {
    props: {
      newBusiness: {
        type: Boolean,
        default: false,
      },
      section_id: {
        type: Number,
        default: null,
      },
    },
    components: {
      DataTable,
      Autocomplete,
    },
    computed: {
      ...mapGetters({
        data: "business/current",
        dataLoading: "business/currentLoading",
        businessList: "business/otherBusinessList",
        businessListLoading: "business/otherBusinessListLoading",
        outcomeAccessList: "business/outcomeAccess/list",
        outcomeAccessListLoading: "business/outcomeAccess/listLoading",
        outcomesList: "outcomes/list",
        outcomesListLoading: "outcomes/listLoading",
      }),
      filteredOutcomesList() {
        return this.outcomesList.filter((e) => {
          if (this.outcomeAccessList.findIndex((o) => e.id == o.outcome_id) < 0) {
            return e;
          }
        });
      },
      outcomeAccessColumns() {
        return [
          {
            name: "id",
            label: "ID",
            align: "left",
            field: "id",
            style:
              "min-width: 90px;max-width: 90px;width: 90px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
            sortable: true,
          },
          {
            name: "outcomeName",
            label: "Outcome Name",
            align: "left",
            field: "name",
            style:
              "min-width: 300px;max-width: 300px;width: 300px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
            sortable: true,
          },
          {
            name: "created_at",
            label: "Created at",
            align: "left",
            field: "created_at",
            format: (val) => {
              return this.$options.filters.gridDateFormat(val);
            },
            style:
              "min-width: 300px;max-width: 300px;width: 300px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
            sortable: true,
          },
          {
            name: "updated_at",
            label: "Updated at",
            align: "left",
            field: "updated_at",
            format: (val) => {
              return this.$options.filters.gridDateFormat(val);
            },
            style:
              "min-width: 300px;max-width: 300px;width: 300px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
            sortable: true,
          },
          {
            name: "actions",
            label: "Actions",
            align: "right",
            field: "delete",
            style:
              "min-width: 150px;max-width: 150px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
          },
        ];
      },
    },

    watch: {
      $route: function () {
        // this.handleRoute();
      },
      data: {
        deep: true,
        handler() {
          this.init();
        },
      },
    },
    data: () => ({
      //tab
      tab: "general",
      tabs: [
        {
          name: "general",
          label: "General",
          isError: false,
        },
        {
          name: "outcomeAccess",
          label: "Outcome Access",
          isError: false,
        },
      ],

      // basicGoal Form Data
      formData: {
        status: "draft",
      },

      //status options
      status: ["draft", "live"],

      saveLoading: false,

      //croppa
      myCroppa: {},
      changeImage: false,

      // Outcome Access
      selectedOutcome: null,
      searchText: "",
    }),
    async mounted() {
      this.loadData();
      // this.handleRoute();
      this.init();
    },
    methods: {
      // GENERAL
      loadData() {
        if (!this.$route.params.hasOwnProperty("business_id")) {
          this.$store.dispatch("business/loadAllOther");
        } else {
          this.$store.dispatch(
            "business/loadByID",
            this.$route.params.business_id
          );
          this.$store.dispatch("outcomes/loadAll");
          this.$store.dispatch("business/outcomeAccess/loadAll", {
            business_id: this.$route.params.business_id,
          });
        }
      },
      loadFormDataFromExistingBusiness(val) {
        if (val) {
          this.formData = JSON.parse(
            JSON.stringify(this.businessList.find((b) => b.id == val))
          );
        } else {
          this.formData = {};
        }
      },
      init() {
        // A new business must start blank. The store's current business is
        // set at boot (loadAuthenticated) and whenever a row is viewed
        // (loadByID) and is never cleared, so it must not seed this form.
        if (this.newBusiness) return;
        if (this.data != null) {
          this.formData = JSON.parse(JSON.stringify(this.data));
          if (this.formData.status == "temp") {
            this.formData.status = "live";
          }
        }
      },
      closeDialog() {
        this.$router.push("/business");
        this.$emit("close");
      },

      // Business
      async save(isClose, isAddNew) {
        //source validation
        const isValid = await this.$refs.form.validate();

        if (isValid) {
          this.saveLoading = true;
          let payload = { ...this.formData };
          //image uploading
          if (this.myCroppa && this.myCroppa.imageSet) {
            payload.image = {
              dataUrl: this.myCroppa.generateDataUrl(),
            };
          } else {
            delete payload.imageUrl;
          }

          try {
            let result = await this.$store.dispatch("business/save", payload);
            if (result.Result == "Success") {
              this.$q.notify({
                position: "top-right",
                type: "positive",
                message: result.Response.Message,
              });
            } else {
              this.$q.notify({
                position: "top-right",
                type: "negative",
                message: "There was an Error, Please try again later",
              });
            }
          } catch (error) {
            this.$q.notify({
              position: "top-right",
              type: "negative",
              message: "There was an Error, Please try again later",
            });
          }

          this.saveLoading = false;

          if (isClose) {
            this.closeDialog();
          }
        }
      },

      // Business Outcome Access
      async addOutcomeAccess() {
        //source validation
        const isValid = await this.$refs.outcomeAccessForm.validate();

        if (isValid) {
          this.saveLoading = true;
          let payload = {
            business_id: this.formData.id,
            outcome_id: this.selectedOutcome,
            status: 1,
          };

          try {
            let result = await this.$store.dispatch(
              "business/outcomeAccess/new",
              payload
            );
            if (result.Result == "Success") {
              this.$q.notify({
                position: "top-right",
                type: "positive",
                message: result.Response.Message,
              });
            } else {
              this.$q.notify({
                position: "top-right",
                type: "negative",
                message: "There was an Error, Please try again later",
              });
            }
          } catch (error) {
            this.$q.notify({
              position: "top-right",
              type: "negative",
              message: "There was an Error, Please try again later",
            });
          }
          this.selectedOutcome = null;

          this.saveLoading = false;
        }
      },
      async saveOutcomeAccess(data) {
        //source validation
        const isValid = await this.$refs.form.validate();

        if (isValid) {
          this.saveLoading = true;

          let payload = {
            id: data.id,
            status: data.status == 1 ? 0 : 1,
            business_id: this.formData.id,
          };

          try {
            let result = await this.$store.dispatch(
              "business/outcomeAccess/save",
              payload
            );
            if (result.Result == "Success") {
              this.$q.notify({
                position: "top-right",
                type: "positive",
                message: result.Response.Message,
              });
            } else {
              this.$q.notify({
                position: "top-right",
                type: "negative",
                message: "There was an Error, Please try again later",
              });
            }
          } catch (error) {
            this.$q.notify({
              position: "top-right",
              type: "negative",
              message: "There was an Error, Please try again later",
            });
          }

          this.saveLoading = false;
        }
      },
    },
  };
</script>
<style lang="scss" scoped>
  .title {
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 700;
    font-size: 20px;
    line-height: 13px;
  }

  .sustainability-button {
    min-width: 151px;
    height: 34px;
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 600;
    font-size: 9px;
    line-height: 11px;
    display: flex;
    align-items: center;
    text-align: center;
  }

  .previewGoalText {
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 400;
    font-size: 13px;
  }

  .tabTitle {
    font-weight: bold;
  }

  .searchbar {
    @media (max-width: 479px) {
      max-width: 115px !important;
    }
  }
</style>
